<template>
  <div class="filter-size">
    <div class="filter-size-content">
      <el-checkbox-group v-model="checkList" @change="change">
        <template v-for="(item, index) in valueList">
          <el-checkbox
            :key="item.id + index"
            :label="item.id + ''"
            v-if="index <= showLength - 1"
          >
            <span>{{ item.name || item.attribute_value }}</span>
            <span v-if="filterItem.count_display" class="size-num">
              ({{ item.filter_count || item.product_count || "0" }})
            </span>
          </el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <v-filterMore
      :payload_num="showLength"
      :max_num="valueList.length"
      :click_method="show_more"
    ></v-filterMore>
  </div>
</template>
<script>
import vFilterMore from "./fillterMore";
export default {
  props: ["filterItem", "payload", "payload_key"],
  data() {
    return {
      valueList: [],
      checkList: [],
      showLength: 5,
    };
  },
  methods: {
    show_more() {
      this.showLength = this.valueList.length;
    },
    set_main_button() {
      let checkbox__input =
        ".filter-size>.filter-size-content .el-checkbox__input";
      this.$(checkbox__input + ">.el-checkbox__inner").removeClass(
        "main_button"
      );
      this.$(checkbox__input + ".is-checked>.el-checkbox__inner").addClass(
        "main_button"
      );
    },
    change(e) {
      this.set_main_button();
      let payload = {
        [this.payload_key]: e,
      };
      this.bus.$emit("changeFilter", payload);
    },
  },
  beforeMount() {
    if (
      this.filterItem.type == "size" &&
      this.filterItem.attribute &&
      this.filterItem.attribute.length
    ) {
      this.valueList = this.filterItem.attribute;
    } else if (
      this.filterItem.type == "tag" &&
      this.filterItem.taxonomy &&
      this.filterItem.taxonomy.length
    ) {
      this.valueList = this.filterItem.taxonomy;
    }
  },
  components: {
    vFilterMore,
  },
  watch: {
    payload: {
      handler(newV) {
        this.checkList = newV;
        this.$nextTick(this.set_main_button);
      },
      deep: true,
      immediate:true
    },
  },
};
</script>
<style scoped lang='scss'>
.filter-size {
  text-align: left;
  .filter-size-content {
    display: flex;
    &::v-deep .el-checkbox-group {
      width: 100%;
      .el-checkbox {
        margin-right: 0;
        width: 100%;
        display: flex;
        align-items: flex-start;
        font-family: "Muli";
        margin-bottom: 12px;
        &:hover {
          opacity: 0.7;
        }
        .el-checkbox__input {
          padding-top: 3px;
          .el-checkbox__inner {
            width: 18px;
            height: 18px;
            border-color: #dcdfe6 !important;
            &::after {
              left: 6px;
              top: 3px;
            }
          }
        }
        &.is-checked .el-checkbox__input {
          .el-checkbox__inner {
            background-color: transparent;
          }
        }
        .el-checkbox__label {
          flex: 1;
          color: #606266;
          display: flex;
          line-height: 24px;
          justify-content: space-between;
          span:first-child {
            white-space: initial;
          }
          .size-num {
            float: right;
          }
        }
      }
    }
  }
}
</style>